import React, { useMemo } from 'react';
import { TweetContentDto } from '../../api/bip-api/types';
import TweetListItem from './TweetListItem';

interface TweetListProps {
  tweets: TweetContentDto[];
  selectedTweetId: string | null;
  isLoading: boolean;
  onSelectTweet: (id: string) => void;
  onCreateNew: () => void;
}

const TweetList: React.FC<TweetListProps> = ({
  tweets,
  selectedTweetId,
  isLoading,
  onSelectTweet,
  onCreateNew,
}) => {
  // Sort by updatedAt descending
  const sortedTweets = useMemo(() => {
    return [...tweets].sort((a, b) => {
      return new Date(b.updatedAt).getTime() - new Date(a.updatedAt).getTime();
    });
  }, [tweets]);
  return (
    <div className="flex flex-col h-full">
      {/* Create New Button */}
      <button
        onClick={onCreateNew}
        className="w-full mb-4 px-4 py-2 bg-blue-600 hover:bg-blue-700 text-white rounded-lg font-medium transition-colors flex items-center justify-center gap-2"
      >
        <svg
          className="w-5 h-5"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M12 4v16m8-8H4"
          />
        </svg>
        Create New
      </button>

      {/* Tweet List */}
      <div className="flex-1 overflow-y-auto space-y-2">
        {isLoading ? (
          <div className="flex items-center justify-center py-8">
            <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-500"></div>
          </div>
        ) : tweets.length === 0 ? (
          <div className="text-center py-8 text-gray-400">
            <p className="text-sm">No tweets created yet.</p>
            <p className="text-sm mt-1">
              Click 'Create New' to generate tweet content.
            </p>
          </div>
        ) : (
          sortedTweets.map((tweet) => (
            <TweetListItem
              key={tweet.id}
              tweet={tweet}
              isSelected={tweet.id === selectedTweetId}
              onClick={() => onSelectTweet(tweet.id)}
            />
          ))
        )}
      </div>
    </div>
  );
};

export default TweetList;
